import {Pipe, PipeTransform} from '@angular/core';
import {Hort360PropertySummary} from '../../../functions/src/types';


@Pipe({
  name: 'propSummaryName'
})
export class PropertySummaryName implements PipeTransform  {
  transform(value: Hort360PropertySummary, maxLength: number = 30) {
    if (!value) {
      return null;
    }
    const result = [value.name, value.address].map(a => (a ? (a + '') : '').trim()).filter(a => !!a).join(', ').substring(0, maxLength);
    if (maxLength === result.length) {
      return result.substring(0, maxLength - 2) + '..';
    } else {
      return result;
    }
  }
}

@Pipe({
  name: 'formatPropertyId'
})
export class PropertyIdFormatter implements PipeTransform  {
  transform(value: string | number, maxLength: number = 5) {
    value = typeof value === 'string' ? value : (value + '');
    if (!value) {
      return null;
    }
    return value.substr(0, maxLength);
  }
}

@Pipe({
  name: 'camelConvert'
})
export class CamelConvertPipe implements PipeTransform  {
  transform(value: string) {
    if ((typeof value) !== 'string') {
      return value;
    }
    const aValue = value.split(/([A-Z][a-z]+|\d+|[\-]+)/); // _ === - && \\ === escape the space
    for (let x = 0; x < value.length; x++) {
      aValue.splice(x, 0, ' ');
      x++;
    }
    value = aValue.join('')
      .replace(/_/gi, ' ')
      .replace(/ \\/gi, '')
      .replace(/\s\s+/g, ' ')
      .trim();
    value = value[0].toUpperCase() + value.substr(1);
    return value;
  }
}

@Pipe({
  name: 'orderby'
})
export class OrderByPipe {
  transform(array: Array<string>, args: string): Array<string> {
    array.sort((a: any, b: any) => {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}

// Mark a property as enumerable in TS
export function enumerable(value: boolean) {
  return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
    descriptor.enumerable = value;
  };
}
